import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/tools/bookmarklet/BookmarkletContent.tsx");
